module.exports = __webpack_public_path__ + "static/media/bg14.be947250.jpeg";